import {Component, OnInit, ViewChild} from '@angular/core';
import {TabsetComponent} from 'ngx-bootstrap';
import {PageService} from 'src/app/shared/layout/services/page.service';

@Component({
    selector: 'app-resultado-regra-tab',
    templateUrl: './resultado-regra-tab.component.html',
    styleUrls: ['./resultado-regra-tab.component.scss']
})
export class ResultadoRegraTabComponent implements OnInit {

    @ViewChild('tabsetComponent', {static: false}) tabSetComponent: TabsetComponent;

    constructor(private page: PageService) {
    }

    ngOnInit() {
        this.page.defineTitle('RESULTADO');
    }

}
